import React from 'react';

const Star = () => {
    return (
        <li><i className="fas fa-star"></i></li>
    );

}
export default Star;